import confetti from "canvas-confetti";

export const fireCelebration = (colors = ["#22d3ee", "#fbbf24", "#34d399", "#e2e8f0"]) => {
    confetti({ particleCount: 90, spread: 70, origin: { y: 0.7 }, colors });
    setTimeout(() => confetti({ particleCount: 45, spread: 110, startVelocity: 35, origin: { y: 0.6 }, colors }), 250);
};
